<template>
  <div class="section section4">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>新基建 <a href="####" class="tit-more more-link">更多</a></h2>
    <div class="subnav">
      <ul class="navbox">
        <li :class="{active: selected ==='zhinengyingyong'}"><a href="####智慧应用" @click.prevent="onQueryData('zhinengyingyong')" class="fs-rem28">智慧应用<i class="hr"></i></a></li>
        <li :class="{active: selected === 'shujuzhineng'}"><a href="####数据智能" @click.prevent="onQueryData('shujuzhineng')" class="fs-rem28">数据智能<i class="hr"></i></a></li>
        <li :class="{active: selected === 'shengtaixitong'}"><a href="####生态系统" @click.prevent="onQueryData('shengtaixitong')" class="fs-rem28">生态系统<i class="hr"></i></a></li>
        <li :class="{active: selected === 'kexinanquan'}"><a href="####可信安全" @click.prevent="onQueryData('kexinanquan')" class="fs-rem28">可信安全<i class="hr"></i></a></li>
        <li :class="{active: selected === 'xinxingwangluo'}"><a href="####新型网络" @click.prevent="onQueryData('xinxingwangluo')" class="fs-rem28">新型网络<i class="hr"></i></a></li>
        <li><a href="####更多" @click.prevent="$router.push('/service')" class="c-blue fs-rem28">更多</a></li>
      </ul>
    </div>
    <div class="w1200 list-container">
      <div class="sec4-list">

        <div class="list-box swiper-container swiperRecommendation">
          <div class="swiper-wrapper" style="transition-duration: 0ms;">
            <div v-for="(item, index) in list" :key="item.rid" class="lst-item swiper-slide p-item" :data-swiper-slide-index="index">
                <a :href="item.url" class="">
                  <div class="flex justify-center">
                    <img class="item-img" :src="formatImg(item.img)" >
                  </div>
                  <div class="lst-txt" >
                    <div class="c-gray-black fs-rem20 lst-tit line-limit-length">
                      {{item.title}}
                    </div>
                    <div class="c-gray-black fs-rem16 lst-date">
                      {{`发布时间:${formatT(item.createTime)}`}}
                    </div>
                    <div class="flex justify-between margin-lr margin-bottom">
                      <div class="c-blue-s">价格面议</div>
                      <div class="cu-tag line-blue" @click="window.location.href=item.url">详情</div>
                    </div>
                    <!-- <a :href="item.url" class="c-blue fs-rem26 lst-btn">查看详情</a> -->
                  </div>
                </a>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
        <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide"></div>
        <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide"></div>
      </div>
    </div>
  </div>
  <!-- /新基建 -->
</template>

<script>
import {
  queryRecommendations
} from '@/api/main';
import { formatImgSrc } from '@/utils/format';
import Swiper from 'swiper';
import GetStaticIndexMixin from '@/mixins/GetStaticIndex.mixin.js'
import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'
export default {
  name: 'NewConstruction',
  mixins: [GetStaticIndexMixin],
  props: {
    msg: String,
  },
  mounted() {

  },
  data() {
    return {
      mySwiper:null,
      list: [],
      selected: 'zhinengyingyong',
      categories: [
        {
          id: 1,
          type: 'wisdomapp',
          name: '智慧应用',
          active: true,
        },
        {
          id: 2,
          type: 'dataai',
          name: '数据智能',
          active: false,
        },
        {
          id: 3,
          type: 'ecosystom',
          name: '生态系统',
          active: false,
        },
        {
          id: 4,
          type: ' security',
          name: '可信安全',
          active: false,
        },
        {
          id: 5,
          type: 'newnet',
          name: ' 新型网络',
          active: false,
        },
      ]
    }
  },
  methods: {
    p_init(){
      this.initData('xinjijian')

      this.mySwiper = new Swiper('.swiperRecommendation', {
        loop: true,
        slidesPerView: 'auto',
        normalizeSlideIndex:false,
        spaceBetween:10,
        initialSlide: 0,
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
      this._queryRecommendations();
      // this.mySwiper.reLoop()
    },
    formatT(ts){
      return this.formatTime(ts)
    },
    resetList() {
      this.list = [];
    },
    onQueryData(typeId) {
      if (typeId === 'more') {
        // 查看更多，跳转详情页面
        return;
      }
      // 切换分类选择
      this.selected = typeId;
      this.resetList();
      this._queryRecommendations();
    },
    // 立即报价
    onGetPrice(item) {
      console.log(item, '立即报价');
    },
    /**
     * 格式化查询数据，拼接图片前缀
     */
    formatData(list = []) {
      list.forEach(item =>{
        item.children.forEach(element => {
          element.img = formatImgSrc(element.img);
          return element;
        });
      })
      return list;
    },
    formatImg(img){
      return formatImgSrc(img)
    },
    _queryRecommendations() {

        this.list = this.StaticIndexs[this.selected];
        // for(var i=0;i<this.StaticIndexs[this.selected].length;i++){
        //   var itm = this.StaticIndexs[this.selected][i]
        //   this.list.push(itm)
        //   if(this.list.length>=6){
        //     return
        //   }
        // }


    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../../mainui.css");
  .list-container {
    min-height: 273px;
  }
  .item-img {
    width: 150px;
    height: 150px;
    margin: 30px;
  }
  .p-item {
    background-color: #FFFFFF;
  }
</style>
